import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import common_en from './languages/en/common.json';
import signIn_en from './languages/en/signIn.json';
import entities_en from './languages/en/entities.json';
import authentication_en from './languages/en/authentication.json';

const resources = {
  en: {
    common: common_en,
    signIn: signIn_en,
    entities: entities_en,
    authentication: authentication_en,
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: 'en',
  fallbackLng: 'en',
  ns: ['common', 'signIn', 'entities', 'authentication'],
  defaultNS: 'common',
  interpolation: { escapeValue: false },
  initImmediate: false,
});

export { i18n };
